import {
  DEFAULT_COHORT,
  cohortA,
  cohortB,
  cohortC,
  cohortD,
  cohortE,
  cohortF,
  cohortG,
  cohortH,
  cohortI,
  cohortJ
} from '@dtx-company/true-common/src/constants/cohorts'
import { useFlowExperiment } from '../useFlowExperiment/useFlowExperiment'

// NOTE: the cohort names have a colon, like `cohort:A`, but the experiment
// values do not, like `cohortA`, so this object does that mapping - it should
// probably get phased out at some point
const CohortNamesForVariation: Record<string, string> = {
  cohortA: cohortA.name,
  cohortB: cohortB.name,
  cohortC: cohortC.name,
  cohortD: cohortD.name,
  cohortE: cohortE.name,
  cohortF: cohortF.name,
  cohortG: cohortG.name,
  cohortH: cohortH.name,
  cohortI: cohortI.name,
  cohortJ: cohortJ.name
}

export function useBrowserCohortName(): string {
  const [variation] = useFlowExperiment('user_cohorts')
  if (variation && variation in CohortNamesForVariation) {
    return CohortNamesForVariation[variation]
  }
  return DEFAULT_COHORT.name
}
